// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2Y0j7","consentsList":"PatientConsents_consentsList__21bdY","consentsListEmpty":"PatientConsents_consentsListEmpty__2W0Np"};